(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["paint-color-explorer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('paint-color-explorer')) {
    customElements.define('paint-color-explorer', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-swatch]');
          if (button) this.selectColor(button);
        }, options);
        this.addEventListener('pointerover', event => {
          if (this.dataset.hover !== 'true' || event.pointerType !== 'mouse') return;
          const button = event.target.closest('[data-swatch]');
          if (!button || button.contains(event.relatedTarget)) return;
          clearTimeout(this.hoverTimer);
          // Avoid loading every shade when the pointer crosses the grid quickly.
          this.hoverTimer = setTimeout(() => this.selectColor(button), 120);
        }, options);
        this.addEventListener('pointerout', event => {
          const button = event.target.closest('[data-swatch]');
          if (button && !button.contains(event.relatedTarget)) clearTimeout(this.hoverTimer);
        }, options);
        this.addEventListener('keydown', event => {
          const button = event.target.closest('[data-swatch]');
          if (!button || !['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End'].includes(event.key)) return;
          const buttons = Array.from(this.querySelectorAll('[data-swatch]'));
          const columns = getComputedStyle(this.querySelector('.pce__grid')).gridTemplateColumns.split(' ').length;
          const steps = { ArrowLeft:-1, ArrowRight:1, ArrowUp:-columns, ArrowDown:columns };
          let index = buttons.indexOf(button);
          index = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : Math.max(0, Math.min(buttons.length - 1, index + steps[event.key]));
          event.preventDefault();
          buttons[index].focus();
          this.selectColor(buttons[index]);
        }, options);
        document.addEventListener('shopify:block:select', event => {
          const button = Array.from(this.querySelectorAll('[data-swatch]')).find(item => item.dataset.block === event.detail?.blockId);
          if (button) this.selectColor(button);
        }, options);
        // Capture image events: load/error do not bubble. This covers the initial image too.
        this.addEventListener('load', event => {
          if (event.target.matches?.('[data-media] img')) this.finishImage(event.target);
        }, { ...options, capture:true });
        this.addEventListener('error', event => {
          if (event.target.matches?.('[data-media] img')) this.finishImage(event.target, true);
        }, { ...options, capture:true });
        const initialImage = this.querySelector('[data-media] img');
        if (initialImage?.complete) this.finishImage(initialImage, !initialImage.naturalWidth);
      }
      disconnectedCallback() {
        clearTimeout(this.hoverTimer);
        this.controller?.abort();
        this.controller = null;
      }
      finishImage(image, failed = false) {
        const media = this.querySelector('[data-media]');
        if (!media?.contains(image)) return;
        this.querySelector('[data-visual]').setAttribute('aria-busy', 'false');
        this.querySelector('[data-loading]').hidden = true;
        if (failed) {
          const message = document.createElement('p');
          message.className = 'pce__empty';
          message.textContent = 'Room preview could not load for this color.';
          media.replaceChildren(message);
          this.querySelector('[data-status]').textContent = message.textContent;
        }
      }
      selectColor(button) {
        clearTimeout(this.hoverTimer);
        if (button.getAttribute('aria-pressed') === 'true') return;
        const data = button.dataset;
        const template = Array.from(this.querySelectorAll('template[data-preview]')).find(item => item.dataset.preview === data.block);
        if (!template) return;
        this.querySelectorAll('[data-swatch]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        this.querySelector('[data-selected-name]').textContent = data.name;
        this.querySelector('[data-selected-base]').textContent = data.base;
        this.querySelector('[data-base-wrap]').hidden = !data.base.trim();
        this.querySelector('[data-caption]').textContent = data.name;
        this.querySelector('[data-dot]').style.background = data.color;
        const link = this.querySelector('[data-store]');
        link.hidden = !data.link;
        if (data.link) link.setAttribute('href', data.link);
        else link.removeAttribute('href');
        const media = this.querySelector('[data-media]');
        const fragment = template.content.cloneNode(true);
        const image = fragment.querySelector('img');
        this.querySelector('[data-visual]').setAttribute('aria-busy', String(!!image));
        this.querySelector('[data-loading]').hidden = !image;
        this.querySelector('[data-status]').textContent = data.name + (data.base.trim() ? '. Base needed: ' + data.base : '') + (image ? '.' : '. Room preview not available.');
        media.replaceChildren(fragment);
        if (image?.complete) this.finishImage(image, !image.naturalWidth);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
